<div class="activity">

  <div class="section mb-5">
    <div class="section-header">
      <h3 class="section-name">{{variables.subTasks}} <span>*</span></h3>
    </div>

    @if (subTasksAiWarning || modifiedSubTasks.length > 0) {
    <div class="ai-modified-warning">
      <mat-icon class="ai-warn-icon">auto_awesome</mat-icon>
      <div>
        <strong>{{ variables?.aiModifiedSubtasks || variables?.aiModifiedSubtasksWarning || 'Se han modificado las siguientes subtareas que ya existían en la estimación:' }}</strong>
        <ul class="ai-modified-list">
          @for (element of modifiedSubTasks; track element) {
          <li>{{ element.task}} - {{element.subTask}}</li>
          }
        </ul>
      </div>
    </div>
    }
    <div>
      <label>{{variables.selectTool}}</label>
      <br>
      <form [formGroup]="formGroup">
        <div style="display: flex; align-items: center;">
          <mat-form-field style="width: 20%;"
            [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}"
            appearance="outline">
            <mat-select formControlName="toolCtrl" placeholder="{{variables.toolName}}">
              <mat-select-trigger>
                {{ formGroup?.value.toolCtrl.name != '' ? formGroup.value.toolCtrl.name : variables.notApplic}}
              </mat-select-trigger>
              @for (item of tools; track item) {
              <mat-option [value]="item">
                {{ item.name != '' ? item?.name.concat(' (').concat(item.productivity).concat("%)") :
                variables.notApplic }}
                <!-- {{item.name}} ({{item.productivity}}%) -->
              </mat-option>
              }
            </mat-select>
            <!-- <input type="number" step="0.01" matInput formControlName="roleCtrl"> -->
            @if (invalidInput) {
            <mat-hint class="error-hint">{{errorMessage}}</mat-hint>
            }
          </mat-form-field>
          <span [ngClass]="{ 'disabled-span': !isAnyCheckboxChecked()}"
            style="width: 52px; margin-left: 5px; margin-bottom: 25px;" (click)="addToolToActivities()">
            <div class="icon-bg">
              <mat-icon>done</mat-icon>
            </div>
          </span>
        </div>
      </form>

    </div>


    <mat-table #table class="table mt-2" [dataSource]="atividades" cdkDropList (cdkDropListDropped)="dropTable($event)"
      [cdkDropListDisabled]="dragDisabled">
      <ng-container matColumnDef="position" sticky>
        <mat-header-cell *matHeaderCellDef style="flex: 0 0 5%; margin-left:15px ;"></mat-header-cell>
        <mat-cell *matCellDef="let item" style="flex: 0 0 5%;  padding-left: 0px;margin-left:15px ;background: local;">
          <span><mat-icon style="vertical-align: middle;" class="dragCursor"
              (mousedown)="dragDisabled = false;">reorder</mat-icon></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef style="border: 0;">
          <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" style="border: 0;">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      @if (estimate.projectMetodology == 'agile') {
      <div>
        <ng-container matColumnDef="epic">
          <mat-header-cell *matHeaderCellDef>Epic</mat-header-cell>
          <mat-cell *matCellDef="let item" class="td-name">{{item.epic == variables.notApplic || item.epic == null ?
            variables.notApplic : item.epic}}</mat-cell>
        </ng-container>
      </div>
      }
      @if (estimate.projectMetodology == 'agile') {
      <div>
        <ng-container matColumnDef="userStory">
          <mat-header-cell *matHeaderCellDef>User Story</mat-header-cell>
          <mat-cell *matCellDef="let item" class="td-name">{{item.userStory == variables.notApplic || item.userStory ==
            null ? variables.notApplic : item.userStory}}</mat-cell>
        </ng-container>
      </div>
      }
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>{{variables.task}}</mat-header-cell>
        <mat-cell *matCellDef="let item" class="td-name">{{item.task}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="activity">
        <mat-header-cell *matHeaderCellDef>{{variables.subTask}}</mat-header-cell>
        <mat-cell *matCellDef="let item" class="td-name">
          {{item.subTask}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="complexityLevel">
        <mat-header-cell *matHeaderCellDef>{{variables.complexity}}</mat-header-cell>
        <mat-cell *matCellDef="let item; let i = index">
          @if (item.complexityLevel === '1') {
          {{variables.low1}}
          }
          @if (item.complexityLevel === '2') {
          {{variables.medium1}}
          }
          @if (item.complexityLevel === '3') {
          {{variables.high1}}
          }
          @if (item.complexityLevel != '1' && item.complexityLevel != '2' && item.complexityLevel != '3') {
          {{variables.notApplic}}
          }
        </mat-cell>
      </ng-container>
      @if (estimate.estimateMode == 'tshirt') {
      <div>
        <ng-container matColumnDef="tshirtScale">
          <mat-header-cell *matHeaderCellDef>T-Shirt size</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <ng-container>{{item.tshirtScaleLevel == variables.notApplic || item.tshirtScaleLevel == null ?
              variables.notApplic : item.tshirtScaleLevel}}</ng-container>
          </mat-cell>
        </ng-container>
      </div>
      }
      <ng-container matColumnDef="itemCount">
        <mat-header-cell *matHeaderCellDef>{{variables.numberOfItems}}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.itemCount}}</mat-cell>
      </ng-container>
      @if (estimate.estimateMode == 'tshirt') {
      <div>
        <ng-container matColumnDef="complexDays">
          <mat-header-cell *matHeaderCellDef>{{variables.effort}} ({{variables.days}})</mat-header-cell>
          <mat-cell *matCellDef="let item">{{((item.complexity)/8).toFixed(2)}}</mat-cell>
        </ng-container>
      </div>
      }
      <ng-container matColumnDef="complexity">
        <mat-header-cell *matHeaderCellDef>{{variables.effort}} (h)</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.complexity.toFixed(2)}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="productivityTool">
        <mat-header-cell *matHeaderCellDef>{{variables.prodTool}}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.tool == null ? variables.notApplic : item.tool.name}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="profile">
        <mat-header-cell *matHeaderCellDef>{{variables.profile}}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{getProfileCenter(item.profileId)}} - {{getProfileName(item.profileId)}} {{getProfileCostPerHour(item.profileId)}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="aiGenerated">
        <mat-header-cell *matHeaderCellDef style="flex: 0 0 36px;"></mat-header-cell>
        <mat-cell *matCellDef="let item" style="flex: 0 0 36px; justify-content: center;">
          @if (item.aiGenerated) {
          <mat-icon class="ai-generated-icon"
            [matTooltip]="variables?.aiReviewTooltip || 'Por favor revise toda la información generada por IA, una vez validada pulse en guardar'">
            auto_awesome
          </mat-icon>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let item; let i = index">
          <div class="action_buttons">
            <span (click)="estimate.projectMetodology != 'agile' ? editItem(item, i) : editItemAgile(item)"
              class="action_buttons-item" style="margin-right: 10px;">
              <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
            </span>
            <span (click)="removeItem(item, i)" class="action_buttons-item" [matTooltip]="variables.remove">
              <img src="../../../../assets/svg/BinWhite.svg" alt="Bin Icon" width="15px">
            </span>
          </div>
        </mat-cell>
      </ng-container>

      @if (estimate.estimateMode == null) {
      <div>
        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns;" cdkDrag [cdkDragData]="row"
          [class.modified-subtask-row]="isModifiedSubTaskRow(row)"></mat-row>
      </div>
      }
      @if (estimate.estimateMode == 'complex') {
      <div>
        <mat-header-row *matHeaderRowDef="columnsComplex"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsComplex;" cdkDrag [cdkDragData]="row"
          [class.modified-subtask-row]="isModifiedSubTaskRow(row)"></mat-row>
      </div>
      }
      @if (estimate.estimateMode == 'tshirt') {
      <div>
        <mat-header-row *matHeaderRowDef="columnsTshirt"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsTshirt;" cdkDrag [cdkDragData]="row"
          [class.modified-subtask-row]="isModifiedSubTaskRow(row)"></mat-row>
      </div>
      }

    </mat-table>

    <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
      <app-button typeBtn="primary" (click)="openDialog()" iconPosition="left" icon="add"
        message="{{variables.addSubTask}}"></app-button>
    </div>

  </div>

  <div class="btn-group">
    <app-button typeBtn="secondary" (click)="back()" class="mr-1" textColor="#FFF" color="#9A9AA9"
      message="{{variables.anterior}}"></app-button>
    <app-button typeBtn="primary" (click)="saveEstimate()" class="mr-1" message="{{ variables.save1 }}"></app-button>
  </div>
</div>